import Vue from 'vue';
// import store from '@/store';

Vue.mixin({
  methods: {

  },
});
